<template>
  <div class="app-page">
    <div class="signup">
      <SignupForm />
    </div>
  </div>
</template>

<script>
import SignupForm from '@/components/SignupForm.vue';

export default {
  name: 'Signup',
  components: {
    SignupForm,
  },
  mounted() {
    this.$store.commit('setTheme', "theme-auzone-light");
  },
};
</script>

<style lang="scss" scoped>
.app-page {
  display: flex;
  flex-direction: row;
  text-align: center;
  overflow: visible;
  height: 100dvh;
  background-color: #250e81 !important;
  background-image: url("@/assets/img/blu-stripes.png") !important;
}

.signup {
  display: flex;
  flex-direction: column;
  flex: 1 1 100%;
  height: 100%;
  padding: 16px 100px;
  align-items: center;
  // justify-content: center;
  overflow: auto;
}

@media (max-width: $breakpoint-sm) {
  .signup {
    padding: 8px;
  }
}
@media (max-width: $breakpoint-md) {
  .signup {
    padding: 16px;
  }
}

</style>
